export default __webpack_public_path__ + "static/media/List-white.9e7b9e58.svg";